export const localStorageKeys = {
  USERNAME: 'username',
  WARN_NOT_ACTIVE_USER: 'warn_not_active_user',
}

export const localstorageUsernameKey = 'username';

export const queryParamToJoin = 'join';